import axios from "axios";
import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";
import type { LoginResponse } from "../types/auth";
import { ApiConfig } from "../config/apiConfig";
import router from "../router";

interface ApiResponse<T = any> {
  success: boolean;
  message: string;
  data: T;
}

const http: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  timeout: 10000,
  headers: { "Content-Type": "application/json" },
});

// 请求拦截器
http.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem('token');
    console.log(token)
    if (!token && !config.url?.includes('/login')) {
      router.push('/login');
      return Promise.reject(new Error('No token, redirect to login'));
    }
    // 可在此处添加全局逻辑（如 token）
    // const token = localStorage.getItem('token')
    // if (token) config.headers!.Authorization = `Bearer ${token}`
    return config;
  },
  (error: any) => Promise.reject(error)
);


// 响应拦截器 - 返回完整响应对象
http.interceptors.response.use(
  (response: AxiosResponse<ApiResponse>) => {
    console.log(response)
    return response;
  },
  (error) => {
    const errMsg = error.response?.data?.message || error.message;
    return Promise.reject(new Error(errMsg));
  }
);

// 带Token的GET请求
export const getWithToken = async <T = any>(
  url: string,
  config?: AxiosRequestConfig
): Promise<T> => {
  const response = await http.get<ApiResponse<T>>(url, {
    ...config,
    headers: {
      ...config?.headers,
      Authorization: `${localStorage.getItem('token')}`
    }
  });
   if (!("data" in response.data)) {
    return response.data as any; // 直接返回数据本身
  }
  return response.data.data;
};

// 登录API
export const login = async (
  username: string,
  password: string
): Promise<LoginResponse> => {
  try {
    const { data } = await http.post<LoginResponse>(ApiConfig.Login, {
      username,
      password
    });
    console.log(data)
    if (!data.success ) {
      throw new Error(data.message || '登录失败');
    }

    localStorage.setItem('token', data.data.token);
    localStorage.setItem('roles', data.data.roles);

    return data;
  } catch (error: any) {
    console.error('Login failed:', error);
    return error;
  }
};

// 基础GET请求
export const get = async <T = any>(
  url: string,
  config?: AxiosRequestConfig
): Promise<T> => {
  const response = await http.get<ApiResponse<T>>(url, config);
  // 返回里没有data 数据
  if (!("data" in response.data)) {
    return response.data as any; // 直接返回数据本身
  }

  return response.data.data;
};

// 基础POST请求
export const post = async <T = any>(
  url: string,
  data?: Record<string, any>,
  config?: AxiosRequestConfig
): Promise<T> => {
  const response = await http.post<ApiResponse<T>>(url, data, config);
  return response.data.data;
};

// 认证检查
export const checkAuth = (): boolean => {
  return !!localStorage.getItem('token');
};

// 获取角色
export const getRoles = (): string | null => {
  return localStorage.getItem('roles');
};
